import {Component, Inject, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {UtilitiesService} from '../../service/utilities.service';
import {StatePersistenceService} from '../../service/state.persistence.service';
import {ActivatedRoute, Router} from '@angular/router';
import {BreadcrumbService} from '../../service/breadcrumb.service';
import {InventoryControllerService, ProductDto, ProductImageDto} from '../../@api';
import {AuthenticationManager} from '../../@shared';
import {HttpClient} from '@angular/common/http';
import {saveAs} from 'file-saver';
import {BrowserStorageService} from '../../service/browser.storage.service';
import {AbstractQuote} from '../../common/quote/abstract-quote';
import {SeoService} from '../../service/seo.service';

@Component({
    selector: 'product',
    templateUrl: './product.component.html',
    styleUrls: ['./../retail.component.scss']
})
export class ProductComponent extends AbstractQuote implements OnInit {

    product: ProductDto;
    images: any[] = [
        {
            previewImageSrc:
                'https://media.geeksforgeeks.org/wp-content/cdn-uploads/20220401124017/HTML-Tutorial.png',
            thumbnailImageSrc:
                'https://media.geeksforgeeks.org/wp-content/cdn-uploads/20220401124017/HTML-Tutorial.png',
            alt: 'Description for Image 4',
            title: 'Title 4'
        },
    ];

    initialised: boolean;

    responsiveOptions:any[] = [
        {
            breakpoint: '1024px',
            numVisible: 5
        },
        {
            breakpoint: '768px',
            numVisible: 3
        },
        {
            breakpoint: '560px',
            numVisible: 1
        }
    ];

    productCode: string;

    constructor(@Inject(DOCUMENT) public override document: Document,
                protected override browser: BrowserStorageService,
                protected override state: StatePersistenceService,
                public authenticationManager: AuthenticationManager,
                private seoService: SeoService,
                private utilities: UtilitiesService,
                private route: ActivatedRoute,
                private inventoryService: InventoryControllerService,
                private http: HttpClient,
                router: Router,
                breadcrumbService: BreadcrumbService) {
        super(document, state, browser, router, breadcrumbService);

        this.productCode = this.route.snapshot.data['productCode'];
    }

    override ngOnInit(): void {
        super.ngOnInit();

        // Set fallback meta tags immediately
        this.seoService.updateMetaTags({
            title: 'Loading Product | Solar Central',
            description: 'Loading product details...',
            keywords: 'solar, product, solar central',
            url: 'https://www.solarcentral.co.za',
            image: 'https://www.solarcentral.co.za/images/logo.png',
        });

        // Get resolved product data
        this.product = this.route.snapshot.data['product'];

        try {
            if (this.product && this.product.name) {
                let title: string = this.product.title;
                let keywords: string = this.product.keywords;
                let description: string = this.product.description;
                let url: string = 'https://www.solarcentral.co.za'
                    .concat(...[super.categoryUri(this.product),'/'])
                    .concat(super.productUri(this.product));
                let canonical: string = url.endsWith('/') ? url : url + '/';
                let image: string = super.imageUri(this.product);

                this.seoService.updateMetaTags({
                    title: title,
                    description: description,
                    keywords: keywords,
                    url: url,
                    image: image
                });
                this.setCanonicalURL(canonical);

                this.product.qty = 1;
                this.product.images = [].concat((this.product.images || []));
                if (this.product.images.length === 0) {
                    this.product.images.push({id: 0, url: this.product.image, deleted: false});
                }

                this.product.images.forEach((i: ProductImageDto): void => {
                    this.images.push({
                        alt: this.product.name,
                        previewImageSrc: i.url,
                        thumbnailImageSrc: i.url,
                        title: this.product.name
                    })
                });
                this.images.splice(0, 1);
            } else {
                // Fallback meta tags if product is not found
                this.seoService.updateMetaTags({
                    title: 'Product Not Found | Solar Central',
                    description: 'Unable to load product details.',
                    keywords: 'solar, product, solar central',
                    url: 'https://www.solarcentral.co.za',
                    image: 'https://www.solarcentral.co.za/images/logo.png',
                });
            }
        } catch (error) {
            console.error('Error processing product:', error);
            // Ensure fallback meta tags are set
            this.seoService.updateMetaTags({
                title: 'Product Error | Solar Central',
                description: 'Error loading product details. ' + error,
                keywords: 'solar, product, solar central',
                url: 'https://www.solarcentral.co.za',
                image: 'https://www.solarcentral.co.za/images/logo.png',
            });
        } finally {
            this.setInitialised();
        }
    }

    setCanonicalURL(url: string): void {
        let link: HTMLLinkElement | null = this.document.querySelector('link[rel="canonical"]');

        if (!link) {
            link = this.document.createElement('link');
            link.setAttribute('rel', 'canonical');
            this.document.head.appendChild(link);
        }

        link.setAttribute('href', url);
    }

    setInitialised(): void {
        setTimeout((): void => {
            this.initialised = true;
        }, 500);
    }

    download(url: string): void {
        let filename: string = url.substring(url.lastIndexOf('/') + 1);
        this.http.get(url, {responseType: 'blob', headers: {'Accept': 'application/pdf'}})
            .subscribe(blob => {
                saveAs(blob, filename);
            });
    }

    navigate(uri: string): void {
        this.router.navigate([uri]);
    }
}
